import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { getRandomKey } from "../utils";
export var Broadcast = /*#__PURE__*/ function() {
    "use strict";
    function Broadcast() {
        var _this = this;
        _class_call_check(this, Broadcast);
        _define_property(this, "broadcast", void 0);
        _define_property(this, "eventBus", {});
        _define_property(this, "handleMap", {});
        var hostTopic = "Panda_Broadcast_Channel";
        this.broadcast = new BroadcastChannel(hostTopic);
        // 同一个BroadcastChannel实例发送的message不能被监听到，所以需要重新实例化一个BroadcastChannel
        new BroadcastChannel(hostTopic).onmessage = function(messageEvent) {
            var _messageEvent_data = messageEvent.data, event = _messageEvent_data.event, data = _messageEvent_data.data;
            if (event) {
                if (_this.eventBus[event]) {
                    Object.keys(_this.eventBus[event]).forEach(function(handleId) {
                        _this.eventBus[event][handleId](data);
                    });
                }
            }
        };
    }
    _create_class(Broadcast, [
        {
            key: "on",
            value: function on(event, callback) {
                if (!this.eventBus[event]) {
                    this.eventBus[event] = {};
                }
                var handleId = getRandomKey();
                this.eventBus[event][handleId] = callback;
                this.handleMap[handleId] = event;
                return handleId;
            }
        },
        {
            /** 制造一个事件 */ key: "emit",
            value: function emit(event, data) {
                this.broadcast.postMessage({
                    event: event,
                    data: data
                });
            }
        },
        {
            /** 取消一个订阅，如果传入句柄则取消某一个订阅 */ key: "off",
            value: function off(eventOrHandleId) {
                if (this.eventBus[eventOrHandleId]) {
                    delete this.eventBus[eventOrHandleId];
                } else {
                    var event = this.handleMap[eventOrHandleId];
                    if (event) {
                        delete this.eventBus[event][eventOrHandleId];
                        delete this.handleMap[eventOrHandleId];
                    }
                }
            }
        }
    ]);
    return Broadcast;
}();
